
export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 rounded-full border-2 border-[#6B8E6F] mb-8">
            <span className="text-[#6B8E6F] text-sm font-medium">Our Approach</span>
          </div>

          <h2 className="text-6xl font-serif text-[#2C2C2C] leading-relaxed max-w-4xl mx-auto">
            We believe in nurturing care<br />
            that feels like family<br />
            in the place you call home
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-20">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#FAF8F5] flex items-center justify-center">
              <i className="ri-heart-pulse-line text-[#6B8E6F] text-3xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#2C2C2C] mb-3">Personalized Care</h3>
            <p className="text-gray-600 leading-relaxed">
              Every care plan is tailored to meet the unique needs and preferences of your loved one
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#FAF8F5] flex items-center justify-center">
              <i className="ri-shield-check-line text-[#6B8E6F] text-3xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#2C2C2C] mb-3">Licensed & Insured</h3>
            <p className="text-gray-600 leading-relaxed">
              Fully licensed, bonded, and insured for your peace of mind and protection
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#FAF8F5] flex items-center justify-center">
              <i className="ri-team-line text-[#6B8E6F] text-3xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#2C2C2C] mb-3">Experienced Team</h3>
            <p className="text-gray-600 leading-relaxed">
              Compassionate caregivers with extensive training and background checks
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
